import React from 'react';
import { Typography, Grid, IconButton, Divider } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

interface WarrantyDisplayProps {
    warranty: any;
}

export const  WarrantyDisplay: React.FC<WarrantyDisplayProps> = ({ warranty }) => {
    if (!warranty) {
        return null;
    }

    return (
        <div style={{ padding: '10px', border: '1px solid #ddd', marginTop: '10px', borderRadius: '4px', backgroundColor: '#fafafa', borderColor: '#e74c3c', maxWidth: 'fit-content' }}>
            <Grid container justifyContent="space-between" alignItems="center" wrap="nowrap">
                <Grid item xs>
                    <Typography variant="body2">
                        <b>Warranty:</b> {warranty.ExtendedDisplayDescription}
                    </Typography>
                    <Typography variant="body2">
                        <b>Price:</b> ${warranty.UnitPrice}
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
};